export * from './CustomizationDetailsDressingWeightV2';
